import { FC, ReactElement, useEffect } from 'react'

import { ChangeLogEntriesContainer } from '../../containers'
import { getChangeLogEntries } from '../../redux/changeLogEntries/changeLogEntriesActions'
import { useTypedDispatch, useTypedSelector } from '../../redux/store'

export const ConnectedChangeLogEntries: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()

    const { isLoading, changeLogEntries } = useTypedSelector(state => state.changeLogEntriesReducer)

    useEffect(() => {
        dispatch(getChangeLogEntries())
    }, [])

    return (
        <ChangeLogEntriesContainer
            isLoading={isLoading}
            changeLogEntries={changeLogEntries}
        />
    )
}
